import { render, staticRenderFns } from "./CreateScreen.vue?vue&type=template&id=0663e364&scoped=true"
import script from "./CreateScreen.vue?vue&type=script&lang=ts"
export * from "./CreateScreen.vue?vue&type=script&lang=ts"
import style0 from "./CreateScreen.vue?vue&type=style&index=0&id=0663e364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0663e364",
  null
  
)

export default component.exports